import { Modal } from 'components/modal'
import { Article as ArticleType } from 'models'
import { FC, useState } from 'react'
import {
  Container,
  Content,
  ContentWrapper,
  Excerpt,
  Footer,
  Image,
  ImageWrapper,
  PlayLabel,
  Subtitle,
  Title,
  Video,
} from './styled'
import { useDataContext } from 'context/data-context'

export const Article: FC<ArticleType & { isWide?: boolean }> = ({
  image,
  title,
  subtitle,
  content,
  footer,
  video,
  isWide = false,
}) => {
  const { strings } = useDataContext()
  const [isOpen, setOpen] = useState(false)

  const handleClick = (
    evt: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    evt.preventDefault()
    setOpen(true)
  }

  return (
    <Container {...(isWide ? { 'data-wide': true } : {})}>
      {video ? (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <ImageWrapper as="a" href="#" onClick={handleClick}>
          <Image src={image} alt={title} />
          {!isWide && <PlayLabel>смотрите сейчас</PlayLabel>}
        </ImageWrapper>
      ) : (
        <ImageWrapper>
          <Image src={image} alt={title} />
          {!isWide && <PlayLabel>смотрите сейчас</PlayLabel>}
        </ImageWrapper>
      )}

      <ContentWrapper>
        <div>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </div>
        <Content>
          <Excerpt>{content}</Excerpt>
          {!!footer && <Footer>{footer}</Footer>}
        </Content>
      </ContentWrapper>

      {!!video && (
        <Modal isOpen={isOpen} onClose={() => setOpen(false)}>
          {video?.startsWith('http') ? (
            <Video controls autoPlay>
              <source src={video} />
            </Video>
          ) : (
            <Video
              as="iframe"
              src={`${strings.video_root_url}${video}.html`}
              scrolling="no"
              allowFullScreen
            ></Video>
          )}
        </Modal>
      )}
    </Container>
  )
}
